<!-- 我的订单 -->
<template>
  <div class="bar_blog">
    <el-row :gutter="0" class="dashed">
      <el-col :span="12">
        <div class="grid-content bg-purple title1">我的心愿愿望</div>
      </el-col>
      <el-col class="clear" :span="12">
        <span class="rt creatPhotoBtn" @click="jump()">+发布心愿愿望</span>
      </el-col>
    </el-row>
    <div class="content" v-if="TravelList">
      <div class="jd-hotList-main mid--1000">
        <ul>
          <li class="my-represent-area" v-for="(item,index) of TravelList.data" :key="index" @click="travelBtn(item)">
            <em class="tag" v-if="item.thankMethod != 0"><i>{{item.thankMethod == 1 ? '代购' : item.thankMethod == 2 ? '抽奖' : '代购+抽奖'}}</i></em>
            <a class="img"><img :src="item.travelImg" height="250" width="320"></a>
            <div class="spot_desc">
              <div class="addr clearfix"><label class="fl">{{item.title}}</label> <a class="fr">详情»</a></div>
              <div class="nums">
                <em class="e1">已筹 {{item.travelMappingMoney}}元</em>
                <em class="e2"> </em>
                <em class="e3">总筹 {{item.travelMoney}}元</em>
              </div>
            </div>
            <div style="padding: 10px">
              <el-progress :text-inside="true" :stroke-width="18" :percentage="(item.travelMoney > item.travelMappingMoney) ?  Math.floor(item.travelMoney / item.travelMappingMoney) : 100  "></el-progress>
                    </div>
          </li>
        </ul>
        <div v-if="TravelList && TravelList.data.length == 0">
          <empty :acceptEmptyData="acceptEmptyData"></empty>
          <p style="text-align: center;margin: 30px 0"><span class="rt creatPhotoBtn" style="float: none" @click="jump()">+发布心愿愿望</span></p>
        </div>
        <p style="text-align: right!important;" v-if="TravelList && TravelList.data.length != 0">
          <el-pagination background @size-change="handleSizeChange" @current-change="pageChange" :current-page="page" :page-sizes="[30, 50, 80, 100]" :page-size="30" layout="total, sizes, prev, pager, next, jumper" :total="totalData">
          </el-pagination>
        </p>
      </div>
      <!--      <div class="my-represent-area" v-for="(item,index) of TravelList.data" :key="index"  @click="travelBtn(item)">-->
      <!--        <div>-->
      <!--          <img :src="item.travelImg" width="100%" alt="">-->
      <!--          <span v-if="Date.parse(new Date()) > item.travelStart && Date.parse(new Date()) > item.travelEnd" class="time_teavel">进行中</span>-->
      <!--          <span v-if="Date.parse(new Date()) > item.travelStart && Date.parse(new Date()) < item.travelEnd" class="time_teavel_not">已结束</span>-->
      <!--        </div>-->
      <!--        <div class="my-represent-content clear">-->
      <!--          <span class="my-represent-txt">心愿：{{item.title}}</span>-->
      <!--&lt;!&ndash;          <span class="rt my-represent-money">心愿筹集:&yen;{{item.travelMoney}}元</span>&ndash;&gt;-->
      <!--        </div>-->
      <!--        <div class="nums">-->
      <!--          <em class="e1">已筹 {{item.travelMappingMoney}}元</em>-->
      <!--          <em class="e2"> </em>-->
      <!--          <em class="e3">总筹 {{item.travelMoney}}元</em>-->
      <!--        </div>-->
      <!--        <div class="my-represent-progress clear">-->
      <!--          <el-progress :text-inside="true" :stroke-width="18" :percentage="Number(item.travelMoney) > Number(item.travelMappingMoney) ?  Number(item.travelMappingMoney) / Number(item.travelMoney) : 100  " status="success"></el-progress>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<!--JS-->
<script>
  import {
    selectTravelList
  } from "api/apis";
  import empty from '../../components/common/empty'
  export default {
    components: {
      empty
    },
    data() {
      return {
        myOrderList: [ //我的订单
          {
            name: '张三三',
            state: 0,
            area: '朝阳区',
            startTime: '2018-11-02',
            stopTime: '2018-12-20',
            money: '720.00',
            num: '3',
            content: '预定服务：景点翻译英文'
          },
          {
            name: '李思',
            state: 1,
            area: '朝阳区',
            startTime: '2018-11-02',
            stopTime: '2018-12-20',
            money: '720.00',
            num: '3',
            content: '预定服务：景点翻译英文'
          },
          {
            name: '张小晨',
            state: 1,
            area: '朝阳区',
            startTime: '2018-11-02',
            stopTime: '2018-12-20',
            money: '720.00',
            num: '3',
            content: '预定服务：景点翻译英文'
          },
          {
            name: '赵五',
            state: 0,
            area: '朝阳区',
            startTime: '2018-11-02',
            stopTime: '2018-12-20',
            money: '720.00',
            num: '3',
            content: '预定服务：景点翻译英文'
          },
        ],
        TravelList: '',
        totalData: 0,
        page: 1,
        pageSize: 30,
        acceptEmptyData: {
          from: 'showImageInfor',
          msg: '您还未发布心愿愿望，可先创建哦～'
        },
      }
    },
    methods: {
      handleSizeChange(val) {
        this.pageSize = val
        // 获取服务服务列表
        this.getList()
        console.log(`每页 ${val} 条`);
      },
      pageChange(val) {
        this.page = val
        // 获取服务服务列表
        this.getList()
        console.log(this.page, val, "翻页")
      },
      jump() {
        this.$router.push({
          name: 'endorsementAdd'
        })
      },
      travelBtn(item) {
        this.$router.push('/homePage?nameCode=' + item.userCode + '&nameTravel=' + item.code)
      },
      getList() {
        let vm = this
        // 获取心愿愿望列表
        selectTravelList({
          map: {
            uid: localStorage.getItem("pbw_user_pc_uid")
          },
          status: 0,
          nowPage: vm.page,
          nowPageDataNum: vm.pageSize,
        }).then((res) => {
          if (res.code == '000000') {
            vm.totalData = res.data.totalDataNum
            vm.TravelList = res.data
          } else {
            vm.$message.warning(res.msg)
          }
        })
      },
    },
    mounted() {
      let vm = this
      // 获取心愿愿望列表
      vm.getList()
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../src/scss/commonH5.scss';
  .creatPhotoBtn {
    color: #f60;
    border: 1px solid #f60;
    font-size: 16px;
    padding: 2px 16px;
    border-radius: 50px;
    cursor: pointer;
    &:hover {
      background: #f60;
      color: #fff;
    }
  }
  .time_teavel {
    position: absolute;
    right: 10px;
    top: 10px;
    background: #f60;
    border: 1px solid #f60;
    padding: 5px 16px;
    border-radius: 5px;
    color: #fff;
    letter-spacing: 3px;
  }
  .time_teavel_not {
    position: absolute;
    right: 10px;
    top: 10px;
    background: #C6C6C6;
    border: 1px solid #C6C6C6;
    padding: 5px 16px;
    border-radius: 5px;
    letter-spacing: 3px;
  }
  /* 基本资料 */
  .avatar {
    height: 120px;
    border-radius: 90px;
    border: 1px solid #d6d6d6;
  }
  .bar_blog .dashed {
    border-bottom: 1px dashed #F1F1F1;
    padding-bottom: 20px;
    margin-bottom: 25px;
  }
  .bar_blog .title1 {
    font-size: 18px;
    color: #333;
  }
  .bar_blog .title1::before {
    content: '';
    display: inline-block;
    width: 5px;
    height: 27px;
    border-radius: 5px;
    vertical-align: bottom;
    background-color: #F16202;
    margin-right: 20px;
  }
  .bar_blog .title2,
  .bar_blog .title2 em {
    text-align: right;
    font-size: 14px;
    color: #959595;
    line-height: 27px;
  }
  .bar_blog .repeatable {
    padding-bottom: 20px;
  }
  .bar_blog .repeatable .name {
    font-size: 14px;
    text-align: right;
    line-height: 40px;
  }
  .bar_blog .repeatable .in input {
    color: #F16202
  }
  .el-border {
    border-radius: 50%;
    width: 100px;
    height: 100px;
    line-height: 100px;
    border: 1px solid #ddd;
    text-align: center;
  }
  .bar_blog .repeatable .sex {
    line-height: 40px;
    padding-left: 10px;
  }
  .name_money {
    padding: 20px 80px;
    border: 1px solid #d5d5d5;
    span {
      color: #f60;
    }
  }
  /*我的心愿*/
  .content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
  .my-represent-area {
    width: 45%;
    border-radius: 5px;
    margin-bottom: 20px;
    box-shadow: 2px 4px 4px 4px rgba(197, 197, 197, 0.3);
    position: relative;
    cursor: pointer;
    img {
      transition: all 0.3s;
      -webkit-transition: all 0.3s;
      -moz-transition: all 0.3s;
    }
     :hover {
      img {
        opacity: 0.8;
        filter: alpha(opacity=80);
        transform: scale(1.03);
        -webkit-transform: scale(1.03);
        -moz-transform: scale(1.03);
      }
    }
    /*img{*/
    /*  height: 175px;*/
    /*  border-top-right-radius: 5px;*/
    /*  border-top-left-radius: 5px;*/
    /*}*/
    .my-represent-content {
      font-size: 16px;
      font-weight: bold;
      padding: 2px 20px;
      color: #666;
    }
    .my-represent-money {
      color: #f60;
    }
    .my-represent-txt {
      display: inline-block;
      -o-text-overflow: ellipsis;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 80%;
    }
    .my-represent-progress {
      padding: 0px 10px 10px;
    }
  }
  .jd-hotList-main ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
  .jd-hotList-main ul li .tag {
    background: url(../../../static/images/icon-label.png) no-repeat;
    color: #fff;
    font-size: 18px;
    padding-left: 8px;
    height: 32px;
    z-index: 10;
    position: absolute;
    top: 20px;
    right: 0;
  }
  .jd-hotList-main ul li .tag i {
    background: #f60;
    display: inline-block;
    padding: 0 10px;
    height: 32px;
    line-height: 32px;
  }
  .jd-hotList-main ul li a.img {
    display: block;
    overflow: hidden;
    height: 200px;
    width: 100%;
  }
  .jd-hotList-main ul li a.img img {
    transition: all 0.3s;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    width: 100%;
  }
  .jd-hotList-main ul li .spot_desc {
    padding: 5px 15px;
  }
  .jd-hotList-main ul li .spot_desc .addr {
    margin-top: 3px;
  }
  .jd-hotList-main ul li .spot_desc .addr label {
    color: #5d5d5d;
    font-size: 14px;
  }
  .jd-hotList-main ul li .spot_desc .addr a {
    color: #f60;
    font-size: 12px;
    margin-top: 1px;
  }
  .jd-hotList-main ul li .spot_desc .addr a:hover {
    text-decoration: underline;
  }
  .jd-hotList-main ul li .spot_desc .nums {
    margin-top: 10px;
    margin-right: -1px;
    overflow: hidden;
    display: flex;
    justify-content: space-between
  }
  .jd-hotList-main ul li .spot_desc .nums em {
    border-right: 1px solid #e8e8e8;
    color: #aaa;
    display: inline;
    float: left;
    font-size: 13px;
    width: 32%;
  }
  .jd-hotList-main ul li .spot_desc .nums .e1 {
    text-align: left;
  }
  .jd-hotList-main ul li .spot_desc .nums .e2 {
    text-align: center;
  }
  .jd-hotList-main ul li .spot_desc .nums .e3 {
    border-right: 0;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/views/home/endorsement.vue